import React from 'react';
import { stencilFiducialData } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const StencilFiducialData = (props) => {
  const name = 'fiducial_data';

  const {
    parameters,
    onChangeParameter,
    groupName,
    errorMessage,
    label,
    options,
    required,
    tooltip,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange || onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      errorMessage={errorMessage} />
  );
};

StencilFiducialData.defaultProps = {
  label: Spree.translations.parameters.fiducial_data,
  tooltip: Spree.helpForParameters.fiducial_data,
  options: stencilFiducialData,
  required: true,
  inputId: 'fiducial-data',
};

export default StencilFiducialData;
